import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Youtube, Facebook, Mail, MapPin, Phone } from "lucide-react";
import axios from "axios";

import { API } from "@/config";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_bwaise-voices/artifacts/1a5a97ee_IMG_9775.jpeg";

export default function Footer() {
  const [contactInfo, setContactInfo] = useState({ email: "goodsamaritanschoirbwaise@gmail.com", phone: "", location: "Bwaise, Kampala, Uganda" });
  const [socialLinks, setSocialLinks] = useState({ youtube: "https://youtube.com/channel/uc17ljgczqpo4dammdqmvwjw", facebook: "https://www.facebook.com/omusamaliya" });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await axios.get(`${API}/settings`);
        if (data.contact_info) setContactInfo(data.contact_info);
        if (data.social_links) setSocialLinks(data.social_links);
      } catch (err) {
        console.error("Failed to load footer settings:", err.message);
      }
    };
    fetchSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- fetch on mount; API is a module constant

  return (
    <footer className="bg-[#1A1A1A] text-white" data-testid="main-footer">
      <div className="section-container py-10 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Logo" className="h-12 w-12 rounded-full" />
              <div>
                <p className="font-bold text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Good Samaritans' Choir Bwaise
                </p>
                <p className="text-[#E8922F] text-sm italic">Love And Unity In God</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Serving through music since 1996. We lift hearts and glorify God through the power of song.
            </p>
          </div>

          <div>
            <h4 className="text-[#E8922F] font-semibold mb-4 text-sm uppercase tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>Quick Links</h4>
            <div className="flex flex-col gap-2">
              {[
                { to: "/about", label: "About Us" },
                { to: "/gallery", label: "Gallery" },
                { to: "/collection/rehearsals", label: "Rehearsals" },
                { to: "/collection/community", label: "Community" },
                { to: "/events", label: "Events" },
                { to: "/donate", label: "Donate" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <Link key={link.to} to={link.to} className="text-gray-400 hover:text-[#E8922F] transition-colors text-sm" data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-[#E8922F] font-semibold mb-4 text-sm uppercase tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>Connect With Us</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3 text-gray-400 text-sm">
                <MapPin size={16} className="text-[#E8922F] flex-shrink-0" />
                {contactInfo.location}
              </div>
              <div className="flex items-center gap-3 text-gray-400 text-sm">
                <Mail size={16} className="text-[#E8922F] flex-shrink-0" />
                {contactInfo.email}
              </div>
              {contactInfo.phone && (
                <div className="flex items-center gap-3 text-gray-400 text-sm">
                  <Phone size={16} className="text-[#E8922F] flex-shrink-0" />
                  {contactInfo.phone}
                </div>
              )}
            </div>
            <div className="flex gap-4 mt-5">
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C4392D] transition-colors" data-testid="footer-youtube-link">
                <Youtube size={18} />
              </a>
              <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C4392D] transition-colors" data-testid="footer-facebook-link">
                <Facebook size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 text-center">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Good Samaritans' Choir Bwaise. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
